import { createContext } from "react";
const FreecashProvider = createContext();
export default FreecashProvider;
